declare let pendo: any;

export const pendoInitialize = (user: any, brand: any, apiKey: string): void => {

  pendo.initialize({
    apiKey: apiKey,
    visitor: {
     id:              user.id,   // Required if user is logged in
     email:           user.email
     // role:         // Optional

     // You can add any additional visitor level key-values here,
     // as long as it's not one of the above reserved names.
    },

   account: {
    id:           brand.brand_id, // Highly recommended
    name:         brand.brand_name
     // planLevel:    // Optional
     // planPrice:    // Optional
     // creationDate: // Optional

     // You can add any additional account level key-values here,
     // as long as it's not one of the above reserved names.
   }
 });
};
